module.exports = __webpack_public_path__ + "assets/icon-graphic-chart-round-bg.976a5700.svg";